<template>
  <div class="tw-text-base tw-text-neutral-900">
    <slot />
  </div>
</template>

